/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';
import { ArrowDownIcon } from './ArrowDownIcon';

const ArrowLeftSvg = () => (
  <ArrowDownIcon style={{ transform: 'rotate(90deg)' }} />
);

export const ArrowLeftIcon = props => <Icon component={ArrowLeftSvg} {...props} />;
